.table {
  width: 100%;
}
